export  function format(value, decimais  = 2) {
  const brlNumber = new Intl.NumberFormat('pt-Br', {
    minimumFractionDigits: decimais,
  })
  return brlNumber.format(value)
}
